import './LoadingScreen.css';

interface LoadingScreenProps {
    /** Optional short line shown under the brand, e.g. "Signing you in…". */
    message?: string;
}

export function LoadingScreen({ message }: LoadingScreenProps) {
    return (
        <div className="loading-screen" role="status" aria-label="Loading" aria-live="polite">
            {/* Wind Particles */}
            <div className="wind-container" aria-hidden="true">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className={`wind-line wind-line-${i + 1}`} />
                ))}
            </div>

            <div className="loading-mark" aria-hidden="true">
                <img src="/brand/logo-mark.svg" alt="" width={160} height={110} />
            </div>

            <div className="loading-content">
                <h2 className="loading-brand">Forest Town</h2>
                {message && <p className="loading-message">{message}</p>}
                <div className="loading-status" aria-hidden="true">
                    <span className="loading-dot">.</span>
                    <span className="loading-dot">.</span>
                    <span className="loading-dot">.</span>
                </div>
            </div>
        </div>
    );
}
